// 整合vant
import Vue from 'vue';
import {
  ActionSheet,
  Toast,
  Dialog,
  Loading,
  ImagePreview,
  NavBar,
  Field,
  DropdownMenu,
  Popover,
  DropdownItem,
  Icon,
  Cell,
  CellGroup,
  List,
  Overlay,
  Radio,
  Form,
  Button,
  Notify,
  PasswordInput,
  NumberKeyboard,
  RadioGroup,
  Grid,
  GridItem,
  Progress,
  Slider,
  Checkbox,
  CheckboxGroup,
  Popup,
  Switch,
} from 'vant'
// 使用 vant
Vue.use(Toast)
  .use(Dialog)
  .use(Cell)
  .use(CellGroup)
  .use(Overlay)
  .use(Radio)
  .use(Notify)
  .use(GridItem)
  .use(Grid)
  .use(Progress)
  .use(Icon)
  .use(Loading)
  .use(Popover)
  .use(ImagePreview)
  .use(DropdownMenu)
  .use(NavBar)
  .use(Checkbox)
  .use(DropdownItem)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Switch)
  .use(ActionSheet)
  .use(Field)
  .use(List)
  .use(Form)
  .use(Button)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(RadioGroup)
  .use(Slider)



// WEBPACK FOOTER //
// ./src/plugins/vant.js